// context/AppointmentsContext.jsx
import React, { createContext, useState, useContext } from 'react';
import { appointmentAPI } from '../services/api';

const AppointmentsContext = createContext({});

export const useAppointments = () => useContext(AppointmentsContext);

export const AppointmentsProvider = ({ children }) => {
  const [appointments, setAppointments] = useState([]);
  const [todayAppointments, setTodayAppointments] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchAppointments = async (params = {}) => {
    setLoading(true);
    try {
      const result = await appointmentAPI.getAppointments(params);
      if (result.success) {
        setAppointments(result.data.appointments || []);
      }
      return result;
    } catch (error) {
      console.error('Failed to fetch appointments:', error);
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const fetchTodayAppointments = async () => {
    try {
      const result = await appointmentAPI.getTodaysAppointments();
      if (result.success) {
        setTodayAppointments(result.data || []);
      }
      return result;
    } catch (error) {
      console.error('Failed to fetch today\'s appointments:', error);
      return { success: false, error: error.message };
    }
  };

  const fetchStats = async () => {
    try {
      const result = await appointmentAPI.getAppointmentStats();
      if (result.success) {
        setStats(result.data);
      }
      return result;
    } catch (error) {
      console.error('Failed to fetch appointment stats:', error);
      return { success: false, error: error.message };
    }
  };

  const createAppointment = async (appointmentData) => {
    try {
      return await appointmentAPI.createAppointment(appointmentData);
    } catch (error) {
      console.error('Failed to create appointment:', error);
      return { success: false, error: error.message };
    }
  };

  const updateAppointment = async (id, appointmentData) => {
    try {
      return await appointmentAPI.updateAppointment(id, appointmentData);
    } catch (error) {
      console.error('Failed to update appointment:', error);
      return { success: false, error: error.message };
    }
  };

  const updateAppointmentStatus = async (id, status, notes) => {
    try {
      return await appointmentAPI.updateAppointmentStatus(id, status, notes);
    } catch (error) {
      console.error('Failed to update appointment status:', error);
      return { success: false, error: error.message };
    }
  };

  const deleteAppointment = async (id) => {
    try {
      const result = await appointmentAPI.deleteAppointment(id);
      if (result.success) {
        setAppointments(appointments.filter(appt => appt.id !== id));
      }
      return result;
    } catch (error) {
      console.error('Failed to delete appointment:', error);
      return { success: false, error: error.message };
    }
  };

  const value = {
    appointments,
    todayAppointments,
    stats,
    loading,
    fetchAppointments,
    fetchTodayAppointments,
    fetchStats,
    createAppointment,
    updateAppointment,
    updateAppointmentStatus,
    deleteAppointment,
  };

  return (
    <AppointmentsContext.Provider value={value}>
      {children}
    </AppointmentsContext.Provider>
  );
};